module.exports = __webpack_public_path__ + "img/icon-sandbox.d041a409.png";